import React, { useMemo, useRef } from "react";
import { getHSNReport } from "../../services/Sales/SalesOrderService";
import { useState } from "react";
import { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { getFormattedNumber } from "../utils/textUtils";
import { Link } from "react-router-dom";

const HSNReport = ({customer, customerCategory, resPacket, startDate, endDate, warehouse }) => {
  const [show, setShow] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});

  useEffect(() => {
    if (!show) {
      setItemList([]);
      setSelectedItem({});
    }
  }, [show]);

  const getSalesReportByItemId = (item) => {
    setSelectedItem(item);
    var request = {
      startDate: startDate,
      endDate: endDate,
      warehouseId: warehouse.value,
      hsnId: "",
      itemId: item.itemUuid,
      customerId:customer,
      customerCategoryId: customerCategory || ""
    };
    getHSNReport(request).then((res) => {
      setItemList(res.responsePacket);
      setShow(true);
    });
  };

  const componentRef = useRef();
  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrint = () => {
    setTimeout(() => {
      handleReactToPrint();
    }, 1000);
  };

  const discountCalculation = (a) => {
    if (parseFloat(a.discountValue) <= 0) {
      return a.amount;
    } else {
      return a.amount * ((100 - a.discountValue) / 100);
    }
  };

  const total = useMemo(() => {
    let acc = {
      unitQty: {},
      unitAmount: {},
      totalUnitQty: 0,
      totalUnitAmount: 0,
      totalAmountWithTax: 0,
    };
    for (let i = 0; i < itemList.length; i++) {
      const cur = itemList[i];
      // Calculation for Quantity
      if (acc.unitQty[cur.unit]) {
        acc.unitQty[cur.unit] += cur.quantity;
        acc.totalUnitQty += cur.quantity;
      } else {
        acc.unitQty[cur.unit] = cur.quantity;
        acc.totalUnitQty += cur.quantity;
      }
      // Calculation for Amount
      const discountedAmount = discountCalculation(cur);

      if (acc.unitAmount[cur.unit]) {
        acc.unitAmount[cur.unit] += discountedAmount;
        acc.totalUnitAmount += discountedAmount;
        acc.totalAmountWithTax =
          acc.totalAmountWithTax +
          discountedAmount +
          (Number(discountedAmount) * Number(cur.taxRate)) / 100;
      } else {
        acc.unitAmount[cur.unit] = discountedAmount;
        acc.totalUnitAmount += discountedAmount;
        acc.totalAmountWithTax =
          acc.totalAmountWithTax +
          discountedAmount +
          (Number(discountedAmount) * Number(cur.taxRate)) / 100;
      }
    }
    return acc;
  }, [itemList]);

  return (
    <>
      {resPacket && resPacket?.length > 0 ? (
        <div className="customTable" id="scroll">
          <table className="customTable w-100">
            <thead className="fixed-thead">
              <tr>
                <th>SNO.</th>
                <th>ITEM</th>
                <th>ITEM CATEGORY</th>
                <td className="text-center">PACK QTY.</td>
                <td className="text-center">OPEN QTY.</td>
                <th className="text-center">TAX RATE</th>
                <th className="text-center">TOTAL AMOUNT</th>
                <th>CONVERSION</th>
              </tr>
            </thead>

            <tbody className="body-scroll-custom">
              {resPacket?.map((a, i) => (
                <tr
                  key={i}
                  onClick={() => getSalesReportByItemId(a)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{i + 1}</td>
                  <td className="item-title-blue">
                    {a?.itemTitle} {`(${a?.hsnSac})`}
                  </td>
                  <td>{a?.category}</td>
                  <td className="text-center">
                    {/* {" "} */}
                    {a?.itemList?.map(
                      (item, i) =>
                        item?.isPackUnit && (
                          <div key={i} className="mx-2">
                            {`${getFormattedNumber(item.quantity)} ${item.unit
                              }`}
                          </div>
                        )
                    )}
                  </td>
                  <td className="text-center">
                    {a?.itemList?.map(
                      (item, i) =>
                        !item.isPackUnit && (
                          <div key={i} className="mx-2">
                            {`${getFormattedNumber(item.quantity)} ${item.unit
                              }`}
                          </div>
                        )
                    )}
                  </td>
                  <td className="text-center">{`${getFormattedNumber(
                    a.itemList?.[0].taxRate
                  )} %`}</td>
                  <td className="text-center">
                    {a?.itemList
                      .reduce((acc, item) => {
                        return (
                          acc +
                          (Number(item.amount) * Number(item.taxRate)) / 100 +
                          Number(item.amount)
                        );
                      }, 0)
                      .toFixed(2)}
                  </td>
                  <td>{a?.altQty}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <>No Record found</>
      )}
      <Modal show={show} onHide={() => setShow(false)} size="xl">
        <div className="d-flex justify-content-between mt-3 mx-4">
          <h3 className="font-size-20">Sales Report</h3>
          <button className="btn hoverBtn p-1" onClick={handlePrint}>
            <LocalPrintshopOutlinedIcon style={{ fontSize: "22px" }} />
          </button>
        </div>
        <Modal.Body>
          <div
            className="custom-table-div standardTable"
            ref={componentRef}
            id="pdf"
            style={{ width: "100%", margin: "15px", color: "black" }}
          >
            <div className="row p-3 align-items-center">
              <div className="col-5">
                <h2 className="font-size-18 font-weight-bold">
                  {selectedItem.itemTitle}{" "}
                  {itemList && ` (${itemList[0]?.hsnSac})`}
                </h2>
              </div>
              <div className="col-7">
                <div className="d-flex justify-content-end align-items-center">
                  <span className="mr-5">Start Date: {startDate}</span>
                  <span>End Date: {endDate}</span>
                </div>
              </div>
            </div>
            <hr style={{ backgroundColor: "#ececec" }} />
            <div>
              {itemList?.length > 0 ? (
                <div>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>SNO.</th>
                        <th>Invoice No.</th>
                        <th>Invoice Date</th>
                        <th>Customer Name</th>
                        <th>Sold Stock</th>
                        <th>Rate</th>
                        <th>Tax Rate(%)</th>
                        <th>Discount</th>
                        <th>Amount</th>
                        <th>Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemList.map((a, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          {/* <Link to={`/invoices/${a.itemUuid}`} target="_blank"> */}
                          <td>{a.invoiceNumber}</td>
                          {/* </Link> */}
                          <td>{a.invoiceDate}</td>
                          <td>{a.salespersonTitle}</td>
                          <td>
                            {Number(a.quantity)?.toFixed(2)}
                            &nbsp;{a.unit}
                          </td>
                          <td>{Number(a.rate)?.toFixed(2)}</td>
                          <td>{Number(a.taxRate)?.toFixed(2)}</td>

                          <td>
                            {a.discountType === "None"
                              ? ""
                              : a.discountType === "Amount"
                                ? `₹ ${Number(a.discountValue)}`
                                : `${Number(a.discountValue)} %`}
                          </td>

                          <td>{Number(discountCalculation(a))?.toFixed(2)}</td>
                          <td>
                            {(
                              Number(discountCalculation(a)) +
                              Number(a.taxesAmount)
                            )?.toFixed(2)}
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td className="border-bottom" colSpan={4}></td>
                        <td className="border-bottom">
                          {Object.keys(total["unitQty"]).map((unit, i) => {
                            return (
                              <>
                                <div
                                  key={"unitQty" + i}
                                  className=" pl-0 border-top-grey"
                                >
                                  <b>{`${total["unitQty"][unit].toFixed(
                                    2
                                  )} ${unit}`}</b>
                                </div>
                              </>
                            );
                          })}
                        </td>
                        <td className="border-bottom"></td>
                        <td className="border-bottom"></td>
                        <td className="border-bottom"></td>

                        <td className="border-bottom">
                          {Object.keys(total["unitAmount"]).map((key, i) => {
                            return (
                              <>
                                <div
                                  key={"unitAmount" + i}
                                  className="border-top-grey"
                                >
                                  <b>{total["unitAmount"][key].toFixed(2)}</b>
                                </div>
                              </>
                            );
                          })}
                        </td>
                        <td className="border-bottom"></td>
                      </tr>
                      <tr>
                        <td></td>
                        <td colSpan={5}>
                          <b>Total</b>
                        </td>
                        {/* <td><b>{total["totalUnitQty"].toFixed(2)}</b> </td> */}
                        <td>{ }</td>
                        <td>{ }</td>
                        <td>
                          <b>{total["totalUnitAmount"].toFixed(2)}</b>
                        </td>
                        <td>
                          <b>{total["totalAmountWithTax"].toFixed(2)}</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ) : (
                <>No Record found</>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HSNReport;
